import React, { useEffect } from 'react';
import { Container } from '@pixi/react';
import { observer } from 'mobx-react-lite';
import { Spine } from '../../../core/classes/spine';
import { gameResourcesService } from '../../../services/gameResourcesService';

const GameBoard = observer(({ containerConfig, gameBoardContainerRef }) => {
  useEffect(() => {
    const board = new Spine({ key: 'board' });
    gameResourcesService.setGameBoardTexture(board);
    board.play('idle', true);
    gameBoardContainerRef.current.addChild(board);
  }, [gameBoardContainerRef]);

  return <Container ref={gameBoardContainerRef} {...containerConfig} name='GameBoardContainer' />;
});

export default GameBoard;
